import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import { equalOrThreeDashes, fromIsoDate } from 'utils';
import { generateFullNameOrBusinessName } from 'utils/string';

import { generateProductGroups, generateStateValue, generateTypeValue } from '../../utils';

const RATableRow = ({ record, raTypesCodelist, raStatesCodelist, raProductGroupsCodelist }) => {
	const { createdOn = '', type = '', state = '', partner = {}, products = [] } = record;
	const { juridicalPerson, naturalPerson, address } = partner;

	return (
		<TableRow>
			<TableCell>
				<div>{equalOrThreeDashes(generateTypeValue(type, raTypesCodelist))}</div>
				<div>{equalOrThreeDashes(generateStateValue(state, raStatesCodelist))}</div>
			</TableCell>
			<TableCell>
				{generateFullNameOrBusinessName(
					juridicalPerson?.name,
					naturalPerson?.surname,
					naturalPerson?.firstName,
				)}
			</TableCell>
			<TableCell>
				<div>{equalOrThreeDashes(naturalPerson?.birthNo)}</div>
				<div>{equalOrThreeDashes(juridicalPerson?.identificationNumber)}</div>
			</TableCell>
			<TableCell>{generateProductGroups(products, raProductGroupsCodelist)}</TableCell>
			<TableCell>
				<div>{equalOrThreeDashes(address?.municipality)}</div>
				<div>{equalOrThreeDashes(address?.zipCode)}</div>
			</TableCell>
			<TableCell>
				<div>{equalOrThreeDashes(fromIsoDate(createdOn))}</div>
			</TableCell>
		</TableRow>
	);
};

RATableRow.propTypes = {
	raProductGroupsCodelist: PropTypes.array,
	raStatesCodelist: PropTypes.array,
	raTypesCodelist: PropTypes.array,
	record: PropTypes.object,
};

export default RATableRow;
